import styled from 'styled-components';

export const RadioButtonStyled = styled.div`
  & + & {
    margin-top: 16px;
  }

  label {
    position: relative;
    display: block;
    cursor: pointer;
  }

  span {
    position: relative;
    display: block;
    padding-top: 2px;
    padding-left: 26px;
    font-size: 0.9rem;
    line-height: 1.3rem;
  }

  &:hover span {
    text-decoration: underline;
  }

  & input {
    position: absolute;
    opacity: 0;
    visibility: hidden;
    appearance: none;
  }

  & input + span::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 0;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    border: solid 1px ${(props) => props.theme.colors.gray300};
  }

  & input + span::before {
    content: '';
    position: absolute;
    top: 7px;
    left: 4px;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    z-index: 1;
    background-color: ${(props) => props.theme.colors.violet200};
  }

  & input:checked + span::after {
    border: solid 1px ${(props) => props.theme.colors.violet500};
  }

  & input:checked + span::before {
    background-color: ${(props) => props.theme.colors.violet500};
  }
`;
